import * as ActionType from '../actions/actionTypes';
// eslint-disable-next-line
import { getData, getDataWithToken, postDataWithToken } from './Services';


export const onGetAcctInfo = payload => {
  return {
    type: ActionType.GET_ACCOUNT_INFO,
    payload,
  };
};

// Bank List
export const onGetBankList = payload => {
  return {
    type: ActionType.GET_BANK_LIST,
    payload,
  };
};
export const onGetBankListSuccess = payload => {
  return {
    type: ActionType.GET_BANK_LIST_SUCCESS,
    payload,
  };
};

export const onGetBankListFail = payload => {
  return {
    type: ActionType.GET_BANK_LIST_FAIL,
    payload,
  };
};


export const getError = payload => {
  return {
    type: ActionType.GET_ERRORS,
    payload,
  }
}



// Create Transaction
export const onStartTransaction = payload => {
  return {
    type: ActionType.CREATE_TRANSACTION,
    payload,
  };
};
export const onTransactionSuccess = payload => {
  return {
    type: ActionType.CREATE_TRANSACTION_SUCCESS,
    payload,
  };
};

export const onTransactionFail = payload => {
  return {
    type: ActionType.CREATE_TRANSACTION_FAIL,
    payload,
  };
};

// Getting Available coins
export const onFetchCoins = payload => {
  return {
    type: ActionType.FETCH_COINS,
    payload,
  };
};
export const onFetchCoinsFail = payload => {
  return {
    type: ActionType.FETCH_COINS_FAIL,
    payload,
  };
};

// Getting Available coins
export const onFetchCoinsPrice = payload => {
  return {
    type: ActionType.FETCH_COINS_PRICE,
    payload,
  };
};

export const onFetchCoinsPriceFail = payload => {
  return {
    type: ActionType.FETCH_COIN_PRICE_FAIL,
    payload,
  };
};






export const fetchCoins = (url) => {
  return getData(url, onFetchCoins, onFetchCoinsFail);
}

export const getBankList = (url) => {
  return getDataWithToken(url, onGetBankListSuccess, onGetBankListFail);
};

export const getCoinPrice = (url) => {
  return getDataWithToken(url, onFetchCoinsPrice, onFetchCoinsPriceFail);
};

export const getAccount = (url, accNo) => {
  return getDataWithToken(url, onGetAcctInfo);
};

export const startTransaction = (url, fields) => {
  return postDataWithToken(url, fields,  onTransactionSuccess, onTransactionFail)
}